<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
         <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <ECMConfirmDialog ref="confirmationDlg" v-model="confirmationDlg"/>
            <ECMRepositoryModal 
                v-model="showECMRepositoryModal"
                ref="ecmRepositoryModal"
                :flag="'RDBMS'"/>
            <b-col>
                <h1>{{ecmResourceStrings.ttlRDBMSRepositories}}</h1>
            </b-col>
            <b-col class="text-right OTbtnContainer" cols="4">
                <b-dropdown text="Actions" right class="OTtableRowDropdown">
                    <b-dropdown-item v-for="action in globalActions" @click="onGlobalAction(action)" :key="action.name">
                        <span :class="'ot-icon-' + action.id" />{{ action.label }}
                    </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <p>
                    {{ecmResourceStrings.txtListOfRDBMSRepositories}}
                </p>
                 <SettingsTable
                :rows="repositories"
                :columns="columns"
                :customOptions="customOptions"
                :actions="actions"
                @sort="sort">
                <template slot="table-header">
                    <h1 class="text-center OT-table-title"></h1>
                </template>
            </SettingsTable>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import SettingsTable from '@/ecm/components/ECMSettingsTable.vue';
import ecmRepositories from '@/ecm/collections/ecmrepositories.js';
import axios from 'axios';
import { showMessage} from '../../../utils/commonECM.js';
import ECMRepository from '@/ecm/models/ecmrepository.js';
import OtifGlobalActions from '../../../../../../mtm-studio-components/src/components/table/GlobalActions.vue';
import { sortOn } from '../../../utils/commonECM.js';
import ECMConfirmDialog from '../../modals/ECMCrawlerConfirmDlg.vue';
import ECMRepositoryModal from '../../modals/ECMCreateRepository.vue';
import { showConfirmationDialog } from '../../../utils/commonECM.js';

export default {
    data() {
        return {
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            sortDir:'asc',
            confirmationDlg:false,
            showECMRepositoryModal: false,
            configs: [],
            ecmRepositories: new ecmRepositories({paginated: false }),
            loaded: false,
            cashedRowNumber:-10001,
            customOptions:  [],
            columns: [
            {
                name: 'repositoryId',
                label: 'ID',
                sortable: true,
                editable:false,
                width:'15%',
                render(row) {
                    return row.attributes.repositoryId;
                }
            },{
                name: 'repositoryType',
                label: 'Connector',
                sortable: true,
                editable:false,
                width:'20%',
                render(row) {
                    return row.attributes.repositoryType;
                }
            },{
                name: 'description',
                label: 'Description',
                sortable: false,
                editable:false,
                render(row) {
                    return row.attributes.description;
                }
            }],
            actions: [{
                    name: 'test',
                    label: 'Test RDBMS Connection',
                    callback: (row) => { this.testRDBMSConnection(row); }
            },{
                    name: 'configuration',
                    label: 'Configuration',
                    callback: (row) => { this.showRepository(row); }
            },{
                    name: 'delete',
                    label: 'Delete',
                    callback: (row) => { this.askDeleteRepository(row); }
            },{
                    name: 'export',
                    label: 'Export',
                    callback: (row) => { this.exportRepository(row); }
            },
            {
                    name: 'smtp',
                    label: 'SMTP notifications',
                    callback: (row) => { this.notificationSMTP(row); }
            }],

            globalActions: [{
                    name: 'add',
                    label: 'Add new RDBMS repository configuration',
                    callback: () => { this.addRepository(); }
                },{
                    name: 'export',
                    label: 'Export',
                    callback: () => { this.allExport();}
                },{
                    name: 'import',
                    label: 'Import',
                    callback: () => { this.allImport();}
                }/*,{
                    name: 'delete',
                    label: 'Delete all RDBMS repositories',
                    callback: () => { this.deleteRepositories(); }
                }*/,{
                    name: 'smtp',
                    label: 'SMTP notifications',
                    callback: () => { this.overviewSMTPNotifications(); }
            }],
        }
    },

    computed: {
        repositories() {
            return this.configs;
        }
    },

    methods: {
        refresh() {
            this.loaded = true;
        },

        sort(colNumber, dir) {
            var that = this;
            that.sortDir = dir;
            if(colNumber == 0)
            {
                that.configs.sort(sortOn('repositoryId', dir));
            }
            if(colNumber == 1)
            {
                that.configs.sort(sortOn('repositoryType', dir));
            }
            //that.configs.sort(sortOn('name', dir));
        },
         
        onGlobalAction(action) {
            if (action['callback']) {
                action.callback(action);
            }
        },

        addRepository(){
            this.showECMRepositoryModal = true;
        },

        deleteRepositories(){
            var that = this;
            that.askDeleteRepository(-1);
        },

        allImport(){
           
           this.$router.push('/settings/rdbmsrepositories/rdbmsrepositoriesimport');
           return;
        },

        overviewSMTPNotifications(){
            this.$router.push('/settings/rdbmsrepositories/overviewsmtp');
            return;
        },

        allExport(){
            this.$snotify.async(this.ecmResourceStrings.txtRDBMSRepositoriesExportStart, {
                timeout: 0
            });
            var that = this;
            axios.get('/mtm-gateway-api/v1/services/ecm/ECMRepositories')
            .then((res) => {
                this.$snotify.clear();
                if (res.data) {
                    var configs = res.data;
                    if(configs)
                    {
                       
                        var i = 0;
                        for(i=configs.ecmRepository.length-1;i>-1;i--)
                        {
                            var onerepo = configs.ecmRepository[i];
                            if(onerepo)
                            {
                                if(onerepo.repositoryType != 'dbms_generic_v1')
                                {
                                    const removed = configs.ecmRepository.splice(i, 1);
                                    
                                }
                            }
                        }
                        const data = JSON.stringify(configs);
                        const blob = new Blob([data], {type: 'text/plain'});
                        const e = document.createEvent('MouseEvents'),
                                a = document.createElement('a');
                        a.download = "rdbmsrepositories.json";
                        a.href = window.URL.createObjectURL(blob);
                        a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                        e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                        a.dispatchEvent(e);
                    }
                    this.$snotify.clear();
                }}
            )
            .catch((err) => {
                this.$snotify.clear();
                this.$snotify.error(this.ecmResourceStrings.txtRDBMSRepositoriesExportFail);
            });
        },

        testRDBMSConnection(rowNumber){
           const repositoryId = this.configs[rowNumber].attributes.repositoryId;
           const repositoryType = this.configs[rowNumber].attributes.repositoryType;
           this.$router.push('/settings/rdbmsrepositories/' + encodeURIComponent(repositoryId) + '/'+ encodeURIComponent(repositoryType) +'/rdbms-test-repo-connection');
        },

        notificationSMTP(rowNumber){
           const repositoryId = this.configs[rowNumber].attributes.repositoryId;
           const repositoryType = this.configs[rowNumber].attributes.repositoryType;
           this.$router.push('/settings/ecmrepositories/' + encodeURIComponent(repositoryId) + '/'+ encodeURIComponent(repositoryType) +'/ecm-repo-smtp-notification');
        },

        showRepository(rowNumber){
            const repositoryId = this.configs[rowNumber].attributes.repositoryId;
            const repositoryType = this.configs[rowNumber].attributes.repositoryType;
            this.$router.push('/settings/rdbmsrepositories/' + encodeURIComponent(repositoryId));
       },

        exportRepository(rowNumber){
            const repositoryId = this.configs[rowNumber].attributes.repositoryId;
            const repositoryName = this.configs[rowNumber].attributes.repositoryName;
            this.$snotify.async(this.ecmResourceStrings.txtRDBMSRepositoryExportStart, {
                timeout: 0
            });
            var that = this;
            try{
                const ecmRepository = new ECMRepository();
                if(ecmRepository)
                {
                    ecmRepository.fetch(repositoryId, {"Content-Type": "application/json; charset=UTF-8"})
                        .then(() => {
                        this.$snotify.clear();
                        if (ecmRepository.attributes) {
                            var configs = ecmRepository.attributes;
                            const data = JSON.stringify(configs);
                            const blob = new Blob([data], {type: 'text/plain'});
                                    const e = document.createEvent('MouseEvents'),
                                    a = document.createElement('a');
                            a.download = "rdbmsrepository_" + repositoryName + ".json";
                            a.href = window.URL.createObjectURL(blob);
                            a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                            e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                            a.dispatchEvent(e);
                            this.$snotify.clear();
                        }})
                        .catch((err) => {
                            this.$snotify.clear();
                            this.$snotify.error(this.ecmResourceStrings.txtRDBMSRepositoryExportFail);
                    });
                }
            }
            catch(err)
            {
                this.$snotify.clear();
                this.$snotify.error(err.message);
            };

            
         },

        saveConfirmed()
        {         
            this.confirmationDlg = false;
            this.deleteRepository();
        },

        deleteAllRepositories()
        {
            var that = this;
            that.$snotify.info(that.ecmResourceStrings.txtStartDeleting);
            axios.delete('/mtm-gateway-api/v1/services/ecm/ECMRepositories')
                .then((res) => {
                        
                        that.cashedRowNumber = -10001;
                        that.$snotify.clear();
                        that.$snotify.success(that.ecmResourceStrings.txtDeleteSuccess);
                        that.refresh();
                    })
                    .catch((err) => {
                        that.$snotify.clear();
                        that.cashedRowNumber = -10001;
                        if(err.description)
                        {
                        that.$snotify.error(that.ecmResourceStrings.txtDeleteError, {
                            buttons: [
                                {text: that.ecmResourceStrings.txtViewDetails, action:()=>that.$eventBus.$emit('show-error-ecm', that.ecmResourceStrings.txtDeleteError, err.message, err.description), bold: true },
                            ],
                        });
                        }
                        else{
                            this.$snotify.error(err.message, that.ecmResourceStrings.txtDeleteError);
                        }
                    });     
            
        },

        deleteRepository(){
            var that = this;

            if (that.cashedRowNumber === -1)
            {
                that.deleteAllRepositories();
                return;
            }

            if (that.cashedRowNumber === -10001)
            {
                  return;
            }
            
            
            that.$snotify.info(that.ecmResourceStrings.txtStartDeleting);
            const repositoryId = this.configs[that.cashedRowNumber].attributes.repositoryId;
            if(repositoryId > -1)
            {
                that.configs[that.cashedRowNumber].delete()
                //axios.delete('/mtm-gateway-api/v1/services/ecm/ECMRepositories/' + repositoryId)
                    .then((res) => {
                        
                        that.cashedRowNumber = -10001;
                        this.$snotify.clear();
                        this.$snotify.success(that.ecmResourceStrings.txtDeleteSuccess);
                        this.refresh();
                    })
                    .catch((err) => {
                        this.$snotify.clear();
                        that.cashedRowNumber = -10001;
                        if(err.description)
                        {
                           that.$snotify.error(that.ecmResourceStrings.txtDeleteError, {
                            buttons: [
                                {text: that.ecmResourceStrings.txtViewDetails, action:()=>that.$eventBus.$emit('show-error-ecm', that.ecmResourceStrings.txtDeleteError, err.message, err.description), bold: true },
                            ],
                        });
                        }
                        else{
                            this.$snotify.error(err.message, that.ecmResourceStrings.txtDeleteError);
                        }
                    });     
            }
            that.cashedRowNumber = -10001;
        },
    
        askDeleteRepository(rowNumber){
            var that = this;
            that.$snotify.clear();
            that.cashedRowNumber = rowNumber;
            if(that.cashedRowNumber == -1)
            {
                showConfirmationDialog(that, 'question', that.ecmResourceStrings.ttlDeleteRepositories, that.ecmResourceStrings.txtDeleteRepositories);
            }
            else
            {
                showConfirmationDialog(that, 'question', that.ecmResourceStrings.ttlDeleteRepository, that.ecmResourceStrings.txtDeleteRepository);
            }
        },

        refresh() {
            var that = this;
            
            that.ecmRepositories.fetch({"Content-Type": "application/json; charset=UTF-8"})
            .then(() => {
                var i = 0;
                that.configs =[];
                for(i=0; i<that.ecmRepositories.resources.length;i++)
                {
                    const rep = that.ecmRepositories.resources[i];
                    if(rep && rep.attributes)
                    {
                        if(rep.attributes.repositoryType == 'dbms_generic_v1')
                        {
                            that.configs.push(rep);
                        }
                    }
                }
            }
        )
        .catch((err) => {
           
        });
        },
    },
    components: {
        SettingsTable,
        OtifGlobalActions,
        ECMConfirmDialog,
        ECMRepositoryModal
    },

    mounted() {
        var breadcrumbs = [{
            name: 'settings',
            meta: { label: 'Settings' }
        },{
            name: 'ecm-repositories',
            meta: { label: 'Repositories' }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
        
        that.ecmRepositories.fetch({"Content-Type": "application/json; charset=UTF-8"})
            .then(() => {
                var i = 0;
                for(i=0; i<that.ecmRepositories.resources.length;i++)
                {
                    const rep = that.ecmRepositories.resources[i];
                    if(rep && rep.attributes)
                    {
                        if(rep.attributes.repositoryType == 'dbms_generic_v1')
                        {
                            that.configs.push(rep);
                        }
                    }
                }
                that.loaded = true;
            }
        )
        .catch((err) => {
            this.$snotify.clear();
            if(err.message)
            {
                this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
            }
            else  if(err.response)
            {
                this.$snotify.error(err.response.data, this.ecmResourceStrings.txtError);
            }
            this.loaded = true;
        });
    }
}

</script>
